import React from 'react'
import { cn } from '@/lib/utils'
import { FileX, Inbox, Search, Users, Calendar, FileText, FolderOpen } from 'lucide-react'
import { Button } from '@/components/ui/button'

const icons = {
  default: Inbox,
  search: Search,
  file: FileX,
  users: Users,
  calendar: Calendar,
  document: FileText,
  folder: FolderOpen,
}

export function EmptyState({
  icon = 'default',
  title = 'No data',
  description,
  action,
  actionLabel,
  onAction,
  className,
}) {
  const Icon = typeof icon === 'string' ? icons[icon] || icons.default : icon

  return (
    <div className={cn(
      "flex flex-col items-center justify-center py-12 px-4 text-center",
      className
    )}>
      <div className="rounded-full bg-muted p-4 mb-4">
        <Icon className="h-8 w-8 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-1">
        {title}
      </h3>
      {description && (
        <p className="text-sm text-muted-foreground max-w-sm mb-4">
          {description}
        </p>
      )}
      {(action || onAction) && (
        <Button onClick={onAction}>
          {actionLabel || 'Take Action'}
        </Button>
      )}
    </div>
  )
}

export default EmptyState
